const DOTS: Record<string, string> = {
  active: "bg-green-500",
  probation: "bg-amber-500",
  suspended: "bg-red-500",
  resigned: "bg-gray-400",
  retired: "bg-blue-400",
  terminated: "bg-red-700",
};

/** Employment status as a coloured dot and label, compact enough for a table row. */
export function StaffStatus({ status }: { status: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium capitalize text-gray-700">
      <span className={`h-1.5 w-1.5 rounded-full ${DOTS[status] || "bg-gray-400"}`} />
      {status.replace(/_/g, " ")}
    </span>
  );
}
